<template>
  <v-dialog :value="value" width="550" persistent>
    <v-card>

      <v-card-title>Filters</v-card-title>

      <v-card-text>

        <v-text-field v-model="email" type="email" label="Email" placeholder="Type here..." hide-details="auto" outlined @input="$v.email.$touch()" @blur="$v.email.$touch()" :error-messages="emailErrors" class="mb-7">
          <template #append-outer>
            <v-btn x-small fab @click="addEmail" :disabled="$v.email.$invalid">
              <v-icon color="secondary" large>{{ mdiPlus }}</v-icon>
            </v-btn>
          </template>
        </v-text-field>

        <v-text-field v-model="phone_number" type="tel" label="Phone" placeholder="Type here..." hide-details="auto" @input="$v.phone_number.$touch()" @blur="$v.phone_number.$touch()" :error-messages="phoneNumberErrors" outlined class="mb-6">
          <template #append-outer>
            <v-btn x-small fab @click="addPhoneNumber" :disabled="$v.phone_number.$invalid">
              <v-icon color="secondary" large>{{ mdiPlus }}</v-icon>
            </v-btn>
          </template>
        </v-text-field>

        <template v-if="showFilterOptions">
          <v-chip-group column class="mb-6">

            <template v-if="configFilters.email.length > 0">
              <template v-for="email in configFilters.email">
                <v-chip small close :key="email" @click:close="removeConfigFilter('email', email)">
                  <span><b>Email:</b> {{ email }}</span>
                </v-chip>
              </template>
            </template>

            <template v-if="configFilters.phone_number.length > 0">
              <template v-for="number in configFilters.phone_number">
                <v-chip small close :key="number" @click:close="removeConfigFilter('phone_number', number)">
                  <span><b>Phone:</b> {{ number }}</span>
                </v-chip>
              </template>
            </template>
            
          </v-chip-group>
        </template>

      </v-card-text>

      <v-divider class="mb-2"></v-divider>

      <v-card-actions class="d-flex justify-space-between">
        <v-btn color="warning" small outlined @click="clearFilter">CLEAR</v-btn>
        <div>
          <v-btn color="primary" small class="mr-2" @click="filterCommsList">FILTER</v-btn>
          <v-btn color="primary" small outlined @click="close">CLOSE</v-btn>
        </div>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import { validationMixin } from 'vuelidate';
  import { email, numeric, minLength, maxLength, and  } from 'vuelidate/lib/validators';
  import { mdiPlus } from '@mdi/js';

  export default {
    mixins: [validationMixin],

    validations: {
      email: {email},
      phone_number: {
        phoneNumber: and(numeric, minLength(10), maxLength(13))      
      }
    },

    props: ['value'],

    data() {
      return {
        mdiPlus,
        email: '',
        phone_number: '',
        configFilters: {
          email: [],
          phone_number: []
        }
      }
    },

    computed: {
      ...mapGetters('comms', ['getCommsListConfig', 'getFetchCommsListError']),

      showFilterOptions() {
        return this.configFilters.email.length > 0 || this.configFilters.phone_number.length > 0;
      },

      emailErrors() {
        const errors = [];

        if (!this.$v.email.$dirty) {
          return errors;
        }

        !this.$v.email.email && errors.push('Email is invalid');

        return errors;
      },

      phoneNumberErrors() {
        const errors = [];

        if (!this.$v.phone_number.$dirty) {
          return errors;
        }

        !this.$v.phone_number.phoneNumber && errors.push('Phone number is invalid');

        return errors;
      }
    },

    watch: {
      value(open) {
        if (open) {
          if(this.getCommsListConfig.queryParams.email) {
            this.configFilters.email = [...this.getCommsListConfig.queryParams.email];
          }

          if(this.getCommsListConfig.queryParams.phone_number) {
            this.configFilters.phone_number = [...this.getCommsListConfig.queryParams.phone_number];
          }
        }
      }
    },

    methods: {
      ...mapActions('comms', ['updateCommsListConfigPagination']),

      addEmail() {
        if (this.email) {
          if (!this.configFilters.email.includes(this.email)) {
            this.configFilters.email.push(this.email);
            this.email = '';
          }
        }     
      },

      addPhoneNumber() {
        if (this.phone_number) {
          if (!this.configFilters.phone_number.includes(this.phone_number)) {
            this.configFilters.phone_number.push(this.phone_number);
            this.phone_number = '';
          }
        }
      },

      removeConfigFilter(option, value) {
        this.configFilters[option] = this.configFilters[option].filter(configFilter => configFilter !== value);
      },

      filterCommsList() {
        this.updateCommsListConfigPagination({
          pagination: {
            page: 1,
          },
          queryParams: {
            ...this.configFilters,
          }
        });

        this.close();
      },

      clearFilter() {
        this.resetFilterInput();
        this.configFilters.email = [];
        this.configFilters.phone_number = [];
      },

      resetFilterInput() {
        this.$v.$reset();
        this.email = '';
        this.phone_number = '';
      },

      close() {
        this.resetFilterInput();
        this.$emit('close');
      }
    }

  }
</script>

<style lang="scss" scoped>
  ::v-deep .v-input__append-outer {
    margin-top: 12px !important;
    margin-bottom: 0 !important;
  }
</style>